import { combineReducers } from 'redux';
import types from './types';

const settings = (state = {}, { type, payload }) => {
  switch (type) {
    case types.getSharepointSettingsSuccess:
      return payload.data;
    default:
      return state;
  }
};

const settingsLoading = (state = false, { type }) => {
  switch (type) {
    case types.getSharepointSettings:
      return true;
    case types.getSharepointSettingsSuccess:
    case types.getSharepointSettingsFailure:
      return false;
    default:
      return state;
  }
};

const sharepointReducers = combineReducers({
  settings,
  settingsLoading,
});

export default { sharepoint: sharepointReducers };
